module.exports = "/images/404f7e7711b30c29d456e5de7a843b3f.png";